const turnosPacienteInitialState = {
  turnosPaciente: {
    loading: false,
    error: null,
    data: null,
    listaMultimedia: null,
    planKinesio: null,
    cambioEstado: null,
    ultimoTurno: null,
    tipoTurno: null,
    circuito: null,
    cancelarSesion: false,
    matriculaMedico: null,
    datosMedico: null,
    turnoSolicitud: null,
    flgOrden: null,
  },
};

export default turnosPacienteInitialState;
